export default function Logo({ className }) {
  return (
    <svg viewBox="0 0 40 40" className={className} data-testid="logo-mark" aria-hidden="true">
      <circle cx="20" cy="20" r="18.5" fill="none" stroke="#E69A3B" strokeWidth="1.6" />
      <g fill="#C83E2B">
        <circle cx="20" cy="12" r="2.3" />
        <circle cx="27.4" cy="15.8" r="2.3" />
        <circle cx="27.4" cy="24.2" r="2.3" />
        <circle cx="20" cy="28" r="2.3" />
        <circle cx="12.6" cy="24.2" r="2.3" />
        <circle cx="12.6" cy="15.8" r="2.3" />
      </g>
      <circle cx="20" cy="20" r="3" fill="#E69A3B" />
    </svg>
  );
}

export function Alpana({ className }) {
  return (
    <svg viewBox="0 0 160 14" className={className} aria-hidden="true" fill="none">
      <circle cx="8" cy="7" r="1.6" fill="#E69A3B" opacity="0.7" />
      <circle cx="26" cy="7" r="2.2" fill="#C83E2B" opacity="0.8" />
      <path d="M44 7 L52 1 L60 7 L52 13 Z" stroke="#E69A3B" strokeWidth="1.2" opacity="0.85" />
      <circle cx="80" cy="7" r="3" fill="#E69A3B" />
      <path d="M100 7 L108 1 L116 7 L108 13 Z" stroke="#E69A3B" strokeWidth="1.2" opacity="0.85" />
      <circle cx="134" cy="7" r="2.2" fill="#C83E2B" opacity="0.8" />
      <circle cx="152" cy="7" r="1.6" fill="#E69A3B" opacity="0.7" />
    </svg>
  );
}
